import React from "react";
import feature from "./assets/feature.png";
import banner from "./assets/banner.png";

const Marketing = () => {
  return (
    <div className="welcome-page-2">
      <div className="faq-page-wrapper">
        <h1>MARKETING: Werbemöglichkeiten</h1>
        <p className="faq-p">
          Du möchtest dein Produkt auf EDEKA StartHub noch mehr pushen und für
          mehr Aufmerksamkeit bei den Kaufleuten sorgen? Dann erfahre hier mehr
          über unsere Werbemöglichkeiten.
        </p>
        <hr />
        <h3>Feature</h3>
        <img
          className="faq-image"
          src={feature}
          alt="screenshot of foodstarter with a 'feature' highlighted"
        />
        <p>
          <strong>
            Wir bringen Dein Produkt wieder auf die erste Seite der
            Händleransicht!
          </strong>
        </p>

        <p>
          Dein Produkt ist Teil der Veröffentlichung und ist für mehrere Wochen
          auf der ersten Seite
          <br />
          Alle Kaufleute werden per Mail darüber informiert und wir machen
          Werbung auf unseren Social-Media-Kanälen.
        </p>

        <p className="faq-p">
          Vor allem neue Kaufleute, die laufend dazukommen, werden auf Dein
          Produkt aufmerksam.
          <br />
          Auch neue Sorten Deiner Produkte können dadurch promotet werden.
        </p>
        <p className="faq-p">Preis: 249€</p>
        <p className="faq-p">
          Buchungslink:{" "}
          <a
            target="_blank"
            rel="noreferrer"
            className="faq-link"
            href="https://forms.office.com/pages/responsepage.aspx?id=hnt6hWYt8kaS4SW-DCfjmHgpqwcHi79JvsfxuoOsihNUMlJDUzRJQ0VNSzJVU0s5RTBCVk9BMldIMS4u"
          >
            Feature
          </a>
        </p>
        <hr />
        <h3>Banner</h3>
        <img
          className="faq-image"
          src={banner}
          alt="screenshot of foodstarter with a banner"
        />
        <p>
          <strong>
            Wir bringen Dein Produkt in den Banner der Händleransicht
          </strong>
        </p>
        <p className="faq-p">
          Der Banner wird kontinuierlich für zwei Wochen auf jeder Seite
          angezeigt und sorgt somit für zusätzliche Aufmerksamkeit.
          <br /> In Verbindung mit einer attraktiven Aktion in Form von
          Naturalrabatt, kann das zum Hit bei den Kaufleuten werden.
        </p>
        <p className="faq-p">
          Vor allem neue Kaufleute, die laufend dazukommen, werden auf Dein
          Produkt aufmerksam. Auch neue Sorten Deiner Produkte können dadurch
          promotet werden.
        </p>
        <p className="faq-p">Preis: 499€</p>
        <p className="faq-p">
          Buchungslink:{" "}
          <a
            target="_blank"
            rel="noreferrer"
            className="faq-link"
            href="https://forms.office.com/pages/responsepage.aspx?id=hnt6hWYt8kaS4SW-DCfjmHgpqwcHi79JvsfxuoOsihNUREhCWTRSNVdTOVVWNFBGR0FEWk9NNElVTC4u"
          >
            Banner
          </a>
        </p>
      </div>
    </div>
  );
};

export default Marketing;
